import { IGalleryItem } from 'src/app/commons/interfaces/gallery-config.interface';

export const STAFF: IGalleryItem[] = [
    {
        path: '/assets/images/staff/milvia.webp',
        description: 'Directora de la escuela. Ganadora del Miss Pole Dance Glamour Per\xFA 2018 y semifinalista en el Elevate Pole dance Chile 2019. Instructora Certificada por Metamorfosis Fit and Pole en Chile, entre otras certificaciones de pole dance en Per\xFA. Formaci\xF3n en ballet y pole dance hace 5 años.',
        title: 'Milvia Urrutia',
        name: 'Milvia Urrutia'
    },
    {
        path: '/assets/images/staff/andrea.webp',
        description: 'Egresada de la carrera de Preparaci\xF3n f\xEDsica en el IDDE. Instructora certificada por Go Pole en Chile, entre otras certificaciones de pole dance en Per\xFA. Formaci\xF3n en gimnasia y pole dance desde hace 5 años.',
        title: 'Andrea Flowers',
        name: 'Andrea F.'
    },
    {
        path: '/assets/images/staff/stheffany.webp',
        description: 'Egresada de la carrera de Formaci\xF3n Art\xEDstica - Especialidad Teatro – Menci\xF3n actuaci\xF3n en la Escuela Nacional Superior de Arte Dram\xE1tico (ENSAD). Formaci\xF3n en ballet y pole dance desde hace 3 años.',
        title: 'Sthefany Montes',
        name: 'Sthefany M.'
    },
    // {
    //     path: '/assets/images/staff/carla.webp',
    //     description: 'Diseñadora de interiores egresada de SENCICO. Formacion en Stretching desde hace 5 años y pole exotic 2 años. Instructora de pole sport nivel básico y certificada en EUPHORIA DANCE COMPLEX - CHILE',
    //     title: 'Carla Larriega',
    //     name: 'Carla Larriega'
    // }
];
